import React from 'react';
import PropTypes from 'prop-types';

const ImageWrapper = ({ big, children }) => (
  <div className="d-flex justify-content-center">
    <div className={`${big ? 'w-50' : 'w-25'} py-4`}>{children}</div>
  </div>
);

ImageWrapper.propTypes = {
  big: PropTypes.bool,
  children: PropTypes.node,
};

export default ImageWrapper;
